import { useEffect } from 'react';
import { Toaster } from 'react-hot-toast';

// The app's ONE toaster. Mounted once, never unmounted, and never joined by a
// second one — and the "never" is the whole point.
//
// WHY ONLY ONE. react-hot-toast 2.6 keeps a list of subscribers per toaster id,
// and a subscriber that unmounts removes THE FIRST entry with its id, not its
// own. The modal used to mount its own <Toaster> to show toasts above its
// backdrop; closing it unsubscribed the app's toaster instead. From then on the
// app's toaster was frozen on its last state: the toast it was showing never
// received its dismissal («Tarea autorizada», for good) and no later toast
// appeared at all. Any `useToaster`/`useToasterStore` that mounts and unmounts
// does the same, so none does.
//
// ABOVE THE MODALS, WITHOUT A SECOND TOASTER. `showModal()` puts a dialog in the
// browser's top layer, where no z-index reaches. A popover lives there too, and
// the last one shown goes on top: so the toaster is a manual popover, shown
// again every time a dialog opens. Where the popover API is missing, it stays
// an ordinary fixed layer — toasts under an open modal, never stuck.

const CONTAINER_CLASS = 'app-toaster';

export default function AppToaster() {
    useEffect(() => {
        const container = document.querySelector(`.${CONTAINER_CLASS}`);
        if (!container || typeof container.showPopover !== 'function') return undefined;

        container.setAttribute('popover', 'manual');

        const raise = () => {
            try {
                if (container.matches(':popover-open')) container.hidePopover();
                container.showPopover();
            } catch {
                // Not connected or not a popover any more: nothing to raise.
            }
        };
        raise();

        // `showModal()` sets `open` on the dialog: a dialog that just opened is
        // on top of the toaster, which goes back above it.
        const observer = new MutationObserver((records) => {
            const opened = records.some(r => r.target instanceof HTMLDialogElement && r.target.open);
            if (opened) raise();
        });
        observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });

        return () => observer.disconnect();
    }, []);

    return <Toaster position="top-right" containerClassName={CONTAINER_CLASS} />;
}
